module.exports = __webpack_public_path__ + "img/banner_left.a42359c4.jpg";